module.exports = __webpack_public_path__ + "img/810f9a8490524109855e0f5fd7e4c468-1024.2c1be93f.png";